import { render, staticRenderFns } from "./ArmVals.vue?vue&type=template&id=909b871e&scoped=true&"
import script from "./ArmVals.vue?vue&type=script&lang=js&"
export * from "./ArmVals.vue?vue&type=script&lang=js&"
import style0 from "./ArmVals.vue?vue&type=style&index=0&id=909b871e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909b871e",
  null
  
)

export default component.exports